import { generatePath } from 'react-router-dom';

interface Params {
  [key: string]: string | undefined;
}

export const generatePathWithParams = (path: string, params?: Params): string => {
  const paramObj = params
    ? Object.keys(params).reduce(
        (acc, key) => ({
          ...acc,
          [key]: params[key] || '',
        }),
        {},
      )
    : {};

  return generatePath(path, paramObj);
};
